module.exports = __webpack_public_path__ + "97df7d49e0871b9eabfc4fd976f5b40d.jpg";